const baseURL = '/express';

async function saveExternal(data) {
    const res = await axios.post(`${baseURL}/external`, data);
    return res.data;
}

export default {
    saveExternal,
};
